import { render, staticRenderFns } from "./ListDissertation_council_member.vue?vue&type=template&id=7c3de5e0&scoped=true"
import script from "./ListDissertation_council_member.vue?vue&type=script&lang=js"
export * from "./ListDissertation_council_member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3de5e0",
  null
  
)

export default component.exports